import React, { createContext, useContext, useState } from 'react';

interface IMessageContext {
    messageContext: {
        queryTagDisabled?: boolean
        messageExpanded?: boolean
    }
    setMessageContext: (context: IMessageContext['messageContext']) => void
}

export type MessageContextType = IMessageContext;

export const MessageContext = createContext<MessageContextType>({ messageContext: {}, setMessageContext: () => { } });

export const useMessageContext = () => {
    return useContext(MessageContext);
};

interface IMessageContextProviderProps {
    children: any
}

function MessageContextProvider({ children }: IMessageContextProviderProps) {
    const [messageContext, setMessageContext] = useState<IMessageContext['messageContext']>({});

    return (
        <MessageContext.Provider value={{ messageContext, setMessageContext }}>
            {children}
        </MessageContext.Provider>
    );
}

export default MessageContextProvider;
